export default function useLoginRedirect() {
  return {
    loginRedirect: localStorage.getItem('LOGIN_REDIRECT') ?? '/',
    setLoginRedirect: (v?: string) => localStorage.setItem('LOGIN_REDIRECT', v ?? '/'),
  };
}
